const API_URL = process.env.REACT_APP_API_URL;

const createFormDataFromMap = map => {
  const formData = new FormData();

  Object.keys(map).forEach(key => {
    const value = map[key];

    if (value instanceof File) {
      // If the value is a File object, append it to the FormData with its name
      formData.append(key, value, value.name);
    } else {
      // Otherwise, append the value as a normal field
      formData.append(key, value);
    }
  });

  return formData;
};

const postData = (
  payload,
  endpointUrl,
  {
    isStaticUrl = false,
    method = 'POST',
    requestBodyMethod,
    noModify = false
  } = {}
) => {
  const requestHeaders = new Headers();
  if (requestBodyMethod === 'raw' || method === 'PUT') {
    requestHeaders.append('Content-Type', 'application/json');
  }
  requestHeaders.append('Accept', 'application/json');
  const userDataJson = window.localStorage.getItem('kerpUserData2.1');
  const parsedUserData = JSON.parse(userDataJson || '{}');

  const requestDataWithUserId = {
    ...payload,
    request_by: parsedUserData.user_id,
    created_by: parsedUserData.user_id
  };
  const requestOptions = {
    method: method,
    headers: requestHeaders,
    body: noModify
      ? payload
      : method === 'PUT' || requestBodyMethod === 'raw'
        ? JSON.stringify(requestDataWithUserId)
        : createFormDataFromMap(requestDataWithUserId)
  };

  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async res => {
    /*Pauses the execution of the program for the specified number of milliseconds.*/

    /*A promise that resolves with the fetched data if the response status is true,
     * or rejects with an error message if there was an error or the response status is false.*/
    fetch(
      isStaticUrl ? endpointUrl : `${API_URL}/${endpointUrl}`,
      requestOptions
    )
      .then(response => {
        return response.json();
      })
      .then(response => {
        if (response.status === true || response.Code === true) {
          return res({ status: true, data: response.data || response.Data });
        } else {
          console.log('🚀 ~ response:-error', response.message);
          return res({
            status: false,
            code: response.code,
            message: response.message || response.Message,
            errors: response.errors
          });
        }
      })
      .catch(err => {
        console.log('🚀 ~ postData ~ err:', err);
        return res({ message: err.message, status: false });
      });
  });
};

export default postData;
